<template>
  <EnrollExamSubjectSetting class="write_exam_query_date"
                       :custom-id="customId"
                       :data-types="dataTypes">
    <template #default="scope">
      <keep-alive>
        <TemplateDataGrid gridId="operaEnrollingExamSubjectList"
                          v-bind="scope"></TemplateDataGrid>
      </keep-alive>
    </template>
  </EnrollExamSubjectSetting>
</template>

<script>
import EnrollExamSubjectSetting from './EnrollExamSubjectSetting'
import TemplateDataGrid from '../../../../../../templates/TemplateDataGrid'
import routeConfig from '../../../../../../../constants/routeConfig'
export default {
  name: 'EnrollExamSubject',
  components: {
    EnrollExamSubjectSetting,
    TemplateDataGrid
  },
  data () {
    return {
      dataTypes: ['enrollBatch'],
      customId: ''
    }
  },
  created () {
    this.customId = this.$route.params[routeConfig.DataTile.param]
  }
}
</script>

<style lang="scss">
.write_exam_query_date {
  height: 100%;
}
</style>
